import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@mui/styles'

import UploadsIcon from '@assets/images/icons/picture_upload.svg'

import Card from './index'

import { fetchDeveloper } from 'redux/ducks/apps'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'

const useStyles = makeStyles(theme => ({
  icon: {
    width: 70,
    height: 70,
    display: 'inline-flex',
    boxShadow: '0px 0px 2px #888',
    borderRadius: 60,
    marginBottom: 20,
    overflow: 'hidden',
    '& img': {
      width: 70,
      height: 70,
    },
  },
  uploadIcon: {
    fill: theme.primary,
    alignItems: 'center',
    margin: 'auto',
    display: 'flex',
  },
  name: {
    fontSize: 15,
    lineHeight: '21px',
    letterSpacing: '0.34px',
    marginBottom: 5,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: theme.textColor,
  },
  developer: {
    fontSize: 10,
    lineHeight: '14px',
    letterSpacing: '0.24px',
    color: theme.textLight,
    paddingBottom: 5,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}))

const AppBaseCard = ({
  name,
  icon,
  developerId,
  className,
  href,
  onClick,
  children,
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { developers } = useSelector(state => state.apps)

  useEffect(() => {
    if (developerId && !developers[developerId]) dispatch(fetchDeveloper(developerId))
  }, [developers, developerId])

  return (
    <Card onClick={onClick} href={href} className={className}>
      <div className={classes.icon}>
        {icon && <img src={icon} />}
        {!icon && (
          <SVGIcon
            height={45}
            width={45}
            svg={UploadsIcon}
            className={classes.uploadIcon}
          />
        )}
      </div>
      <div className={classes.name}>{name}</div>
      <div className={classes.developer}>{developers[developerId]?.name ? `von ${developers[developerId].name}` : ''}</div>
      {children}
    </Card>
  )
}

AppBaseCard.propTypes = {
  name: PropTypes.string,
  icon: PropTypes.string,
  className: PropTypes.string,
  href: PropTypes.string.isRequired,
}

AppBaseCard.defaultProps = {
  name: '',
  icon: '',
  className: null,
  href: '#',
}

export default AppBaseCard
